<script lang="ts">
  export let coreTeam: boolean
  export let avatar: string
  export let position: string
  export let xLink: string
  export let name: string
  export let backgroundImageStyle: string
  import xLogo from 'branding/twitter.png'
</script>

<li
  class="grid w-[100%] items-baseline justify-between border-t border-[#323948] px-2 pt-4 last:border-r-0 lg-desktop:justify-evenly lg-desktop:border-y lg-desktop:border-r lg-desktop:p-8"
>
  <div class="flex items-end lg-desktop:block lg-desktop:justify-self-center">
    <div
      class="bg- relative flex h-12 w-12 items-center justify-center overflow-hidden rounded-full lg-desktop:h-32 lg-desktop:w-32 {coreTeam
        ? 'bg-flame'
        : 'bg-magma'}"
    >
      <div
        class="absolute inset-0 rounded-full bg-cover bg-no-repeat {backgroundImageStyle}"
        style="background-image: url('{avatar}');"
      ></div>
    </div>
    <h5 class="ml-4 font-cirka text-2xl font-medium lg-desktop:hidden">{name}</h5>
  </div>
  <h5
    class=" hidden font-cirka text-2xl font-medium lg:justify-self-center lg-desktop:mt-16 lg-desktop:block lg-desktop:text-[2rem]"
  >
    {name}
  </h5>
  <a
    href={xLink}
    target="_blank"
    rel="noreferrer"
    aria-label="{name} on X"
    class="col-start-2 row-span-2 row-start-1 flex size-11 items-center justify-center pb-[4px] lg-desktop:col-start-1 lg-desktop:row-start-2 lg-desktop:mt-4 lg-desktop:justify-self-center lg-desktop:pb-0"
  >
    <img src={xLogo} alt="Twitter Logo" class="w-8" />
  </a>
  <p class="mt-4 text-[14px] lg-desktop:mt-0 lg-desktop:justify-self-center">{position}</p>
</li>

<style lang="postcss">
  @screen lg-desktop {
    li:nth-child(3) {
      @apply border-r-0;
    }
  }
</style>
